import React, { useState, useEffect, useCallback } from 'react';
import {
  Table, Button, Typography, Select, Row, Col, Image
} from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import moment from 'moment';
import { DEFAULT_AGENCY_IMAGE } from '../../../common/awsBucket';
import CatalogAbroadProcessFormModal from './components/CatalogAbroadProcessFormModal';
import ActionsColumn from './components/ActionsColumn';
import AdvancedSearchForm from '../../../common/SearchForm';

const { Title } = Typography;
const { Option } = Select;

function Category(props) {
  const [modalVisible, setModalVisible] = useState(false);
  const [searchOption, setSearchOption] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };
  const hideModal = () => {
    setModalVisible(false);
  };

  const onAddAbroadProcess = async (payload) => {
    const payloadObj = { abroad_process_flow: payload }
    await props.addAtmedCategoriesAbroadProcessFlow(payloadObj);
    await props.getAllAtmedCategoriesAbroadProcessFlow();
    hideModal();
  };

  const onUpdateCountry = async (payloadObj) => {
    const payload = {
      id: payloadObj.id,
      payload: { abroad_process_flow: payloadObj.payload }
    }
    await props.updateAtmedCategoriesAbroadProcessFlow(payload);
    await props.getAllAtmedCategoriesAbroadProcessFlow();
  };

  const onDeleteCountry = async (payloadObj) => {
    await props.deleteAtmedCategoriesAbroadProcessFlow(payloadObj);
    await props.getAllAtmedCategoriesAbroadProcessFlow();
  };

  const renderData = useCallback(() => {
    props.getAllAtmedCategoriesAbroadProcessFlow.call();
  }, [props.getAllAtmedCategoriesAbroadProcessFlow, props.addCategorySuccess, props.updateCategorySuccess])

  useEffect(() => {
    renderData();
  }, [renderData]);

  const columns = [
    {
      title: 'Title',
      key: 'title',
      dataIndex: 'title',
      render: (_, columnData) => (
        <Row>
          <Col className="table-fc-image">
            <Image
              src={columnData.pic_url ? columnData.pic_url : DEFAULT_AGENCY_IMAGE}
              preview={false}
            />
          </Col>
          <Col offset={1}>
            <div className="table-fc-name">{columnData.title}</div>
            <div className="table-fc-status">
              {columnData.status ? (
                <span className="activate">Active</span>
              ) : (
                <span className="inActivateNotverified">Blocked</span>
              )}
            </div>
          </Col>
        </Row>
      ),
    },
    {
      title: 'Description',
      key: 'subtitle',
      dataIndex: 'subtitle',
      className: 'date-time',
      render: (_, columnData) => (
        <>
          <p>{columnData.subtitle}</p>
        </>
      )
    },
    {
      title: 'CREATED',
      key: 'status',
      dataIndex: 'status',
      className: 'date-time',
      render: (_, columnData) => (
        <>
          <p>{moment(columnData.created_at).format('MM/DD/YYYY')}</p>
          <p>{moment(columnData.created_at).format('hh:mm A')}</p>
        </>
      )
    },
    {
      title: 'MORE',
      key: 'actions',
      render: (_, columnData) => (
        <ActionsColumn
          columnData={columnData}
          onUpdateCountry={onUpdateCountry}
          getLabTestDetailInfo={props.getLabTestDetailInfo}
          onDeleteCountry={onDeleteCountry}
          props={props}
        />
      ),
    },
  ];
  const onSearch = (values) => {
    const newValues = JSON.parse(JSON.stringify(values));
    const queryString = Object.keys(newValues)
      .map((key) => `${key}=${newValues[key]}`)
      .join('&');
    props.getAllAtmedCategoriesAbroadProcessFlow(queryString);
  };

  const toggleSearch = () => {
    setSearchOption(!searchOption)
  };

  return (
    <div>
      <CatalogAbroadProcessFormModal
        onSubmit={onAddAbroadProcess}
        onCancel={hideModal}
        visible={modalVisible}
        title="Add Process"
        submitText="ADD PROCESS"
      />
      <Row
        gutter={[0, 16]}
      >
        <Col className="gutter-row section-heading" span={12} offset={0}>
          <Title
            level={2}
            className="d-flex"
            style={{ justifyContent: 'space-between', alignItems: 'center' }}
          >
            Abroad Process Flow
          </Title>
        </Col>
        <Col className="gutter-row" span={5} offset={0}>
        </Col>
        <Col className="gutter-row header-buttons" span={3} offset={0}>
          <Button className={`${searchOption === true ? 'search-open' : 'search-close'} search-toggle-button`} onClick={() => toggleSearch()}>
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col className="gutter-row header-buttons" span={4} offset={0}>
          <Button onClick={showModal} icon={<PlusOutlined />} type="primary">
            <span style={{ fontWeight: '500' }}>
              ADD PROCESS
            </span>
          </Button>
        </Col>
      </Row>
      {searchOption === true ?
        <AdvancedSearchForm
          onSearch={onSearch}
          onClose={() => setSearchOption(false)}
          title="Catalog - Lab Tests"
          formItems={[
            {
              key: 'q[title_cont]',
              label: 'Title',
            },
            {
              key: 'q[subtitle_cont]',
              label: 'Description',
            },
            {
              key: 'q[status_eq]',
              label: 'Status',
              Component: (
                <Select placeholder="Status - Active / Blocked" size="large">
                  <Option>Active</Option>
                  <Option value={false}>Blocked</Option>
                </Select>
              ),
            },

          ]}
        /> : ''}
      <Table className="list_table" pagination={{ pageSize: 25 }} dataSource={props.categories} columns={columns} scroll={{ x: 800 }} rowKey="id" />
    </div>
  );
}

export default Category;
